<template>
  <div
    v-if="!ratesLoading"
    :class="settings ? 'settings' : 'no-settings'"
    class="page rate-page grid grid--full p0">
    <app-title
      v-if="!isEditing"
      :page="rate.name"
      :class="'grid-column-start-1 grid-column-end-4_sm grid-column-end-5_lg'">
      <div slot="content">
        <div
          v-if="rate.description"
          class="measure font-size-4"><vue-markdown>{{ rate.description }}</vue-markdown></div>
        <p
          v-else
          class="font-size-4">Set your goals, then click the boxes below to see the break down.</p>
        <p class="mb0"><button
          class="invisible-button"
          @click.prevent="isEditing =! isEditing">Edit</button> <button
            class="right invisible-button hide_sm"
            @click.prevent="settings =! settings">Show settings</button></p>
      </div>
    </app-title>
    <app-edit-rate-card
      v-if="isEditing"
      :rc="rate"
      :page="page"
      :is-editing.sync="isEditing"
      :is-confirming.sync="isConfirming"
      class="mb2 grid-column-start-1 grid-column-span-3_sm grid-column-span-4_lg edit-rate"/>
    <div class="grid-row-span-2_sm parameters">
      <rate-parameters
        :class="['rates', settings ? 'showing' : '']"
        :settings.sync="settings"
        :currency="organization.currency"/>
    </div>
    <rate-cards :class="'grid-column-start-1 grid-column-span-3_sm grid-column-span-4_lg cards'" />
    <transition name="slide-right-left">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import page from '../mixins/page'
import RateCards from './RateCards'
import RateParameters from './RateParameters'
import EditRateCard from './EditRateCard'
import VueMarkdown from 'vue-markdown'

export default {
  components: {
    appEditRateCard: EditRateCard,
    rateCards: RateCards,
    rateParameters: RateParameters,
    vueMarkdown: VueMarkdown
  },
  mixins: [ page ],
  data () {
    return {
      isEditing: false,
      isConfirming: false,
      settings: false,
      details: false
    }
  },
  computed: {
    ...mapGetters([
      'ratesLoading',
      'organization'
    ]),
    rate () {
      return this.$store.getters.rateCard(this.page)
    }
  },
  watch: {
    settings (value) {
      if (this.settings) {
        const root = document.getElementsByTagName('html')[0]
        root.classList.add('settings-open')
        document.body.classList.add('settings-open')
      } else {
        const root = document.getElementsByTagName('html')[0]
        root.classList.remove('settings-open')
        document.body.classList.remove('settings-open')
      }
    }
  },
  methods: {
    duplicate () {
      this.$store.dispatch('toggleLoading', true)
      this.$store.dispatch('saveState', false)
      const payload = { ...this.rate }
      this.$store.dispatch('duplicateRate', payload).then(response => {
        this.$router.push({ name: 'rates' })
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style scoped>
  body.overflow-hidden .parameters {
    height: 100vh;
    overflow: auto;
  }
  .rates {
    position: fixed;
    top: calc(var(--line) * 2.5);
    bottom: 0;
    width: 100%;
    z-index: 10;
    -webkit-overflow-scrolling: touch;
  }
  .rates{
    animation: rates-out .3s ease-in forwards;
  }
  .rates.showing {
    animation: rates-in .2s ease-out forwards;
    z-index: 100;
  }
  .edit-rate {
    animation: slide-in-top 0.2s ease;
  }
  @keyframes rates-in {
    from {
      transform: translateY(150%);
    }
    to {

      transform: translateY(0%);
    }
  }
  @keyframes rates-out {
    from {
      transform: translateY(0%);
    }
    to {

      transform: translateY(150%);
    }
  }
  @media screen and (min-width: 48em) {
    .rate-page {
      grid-template-columns: 1fr 1fr 1fr auto;
      grid-template-rows: auto 1fr;
    }
    .rates,
    .rates.showing {
      position: relative;
      transform-origin: 100% 0%;
      bottom: 0;
      width: calc(var(--line)*12);
      transform: translate(0%, 0%);
      animation: none;
      height: 100%;
      padding-top: calc(var(--line)*5);
      top: 0;
      z-index: 0;
    }
    .cards {
      grid-template-rows: auto auto auto auto auto;
    }
  }
  @media screen and (min-width: 64em) {
    .rates,
    .rates.showing {
      width: calc(var(--line)*15);
    }
  }
  @media screen and (min-width: 98em) {
    .rate-page {
      grid-template-columns: 1fr 1fr 1fr 1fr auto;
    }

  }
</style>
